import {useContext, useMemo} from 'react'

import {createAsyncSha256} from '@s-ui/js/lib/hash'
import Context from '@s-ui/react-context'
import {AuthenticationContext} from '@adv-mt/mt-context-authentication'

import {SITE_TYPES} from './config.js'

const useCriteoConfig = () => {
  const {domain} = useContext(Context)
  const {user} = useContext(AuthenticationContext)
  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  const _getCriteoConfig = async () => {
    const {userId: customerId, email = ''} = user || {}
    const hashedEmail = email ? await createAsyncSha256(email) : email
    const siteType = isMobile ? SITE_TYPES.MOBILE : SITE_TYPES.DESKTOP

    return {
      hashedEmail,
      hashMethod: 'sha256',
      customerId,
      siteType
    }
  }

  const memoizedCriteoConfig = useMemo(_getCriteoConfig, []) //eslint-disable-line

  return {config: memoizedCriteoConfig}
}

export default useCriteoConfig
